import { route } from "quasar/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import { setCssVar } from "quasar";
import routes from "./routes";
import { useRandomPalette } from "src/composables/useRandomPalette";

export default route(function ({}) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    if (process.env.SERVER) {
      next();
      return;
    }
    const { getRandomPalette } = useRandomPalette();
    const selectedPalette = getRandomPalette();
    if (selectedPalette) {
      setCssVar("primary", selectedPalette.primary.hex);
      setCssVar("secondary", selectedPalette.secondary.hex);
      setCssVar("accent", selectedPalette.accent.hex);
      setCssVar("info", selectedPalette.quad.hex);
    }

    next();
  });

  return Router;
});
